import React from "react";
import ServicePageTemplate from "../../components/ServicePageTemplate";
import { Landmark } from "lucide-react";

const TempleHeritage = () => {
  const serviceData = {
    serviceName: "Temple & Heritage Place Visit Charters",
    heroImage: "https://images.unsplash.com/photo-1559770968-53924e9b32de",
    heroTagline: "Spiritual Journeys Elevated",
    heroDescription:
      "Experience divine pilgrimages with comfort and convenience. Our temple and heritage charter services take you to sacred destinations across India in style.",
    overviewTitle: "Pilgrimage & Heritage Site Helicopter Charters",
    overviewText: `HighKraft Aviation offers specialized helicopter charter services for pilgrims and travelers seeking to visit temples, religious sites, and heritage destinations. Experience the divine without the exhausting journey – reach your spiritual destination refreshed and ready for darshan.

India's most sacred temples and heritage sites are often located in remote, mountainous, or hard-to-reach areas. Our helicopter pilgrimage service eliminates the challenges of difficult terrain, long drives, and crowded roads, allowing devotees of all ages to fulfill their spiritual aspirations.

From the holy shrines of Char Dham to ancient temples in South India, from Jain pilgrimage sites to Buddhist heritage locations, our charter service opens up possibilities for meaningful spiritual journeys. Senior citizens, families with children, and those with limited mobility can now undertake pilgrimages that were previously challenging.`,
    useCases: [
      {
        title: "Char Dham Yatra",
        description:
          "Helicopter service to Kedarnath, Badrinath, Gangotri, and Yamunotri.",
      },
      {
        title: "South Indian Temples",
        description:
          "Quick access to Tirupati, Shirdi, and other major temple destinations.",
      },
      {
        title: "Jain Pilgrimage",
        description:
          "Comfortable travel to Palitana, Shravanabelagola, and Jain teerths.",
      },
      {
        title: "Heritage Site Tours",
        description:
          "Aerial access to UNESCO heritage sites and historical monuments.",
      },
      {
        title: "Group Pilgrimages",
        description:
          "Organized pilgrimage tours for families and devotee groups.",
      },
      {
        title: "Senior Citizen Yatras",
        description: "Comfortable pilgrimage options for elderly devotees.",
      },
    ],
    safetyFeatures: [
      {
        title: "Mountain Flying Expertise",
        description:
          "Pilots trained and experienced in high-altitude and mountain operations.",
      },
      {
        title: "Weather Intelligence",
        description:
          "Advanced weather monitoring for safe flying in varying conditions.",
      },
      {
        title: "Emergency Preparedness",
        description:
          "Equipped for medical emergencies and mountain rescue coordination.",
      },
      {
        title: "Verified Helipads",
        description:
          "Operations only from DGCA-approved and verified helipad locations.",
      },
      {
        title: "Altitude Briefings",
        description:
          "Pre-flight briefings on high-altitude travel considerations.",
      },
      {
        title: "Comprehensive Insurance",
        description:
          "Travel and medical insurance options for pilgrimage journeys.",
      },
    ],
    galleryImages: [
      "https://images.unsplash.com/photo-1559770968-53924e9b32de",
      "https://images.pexels.com/photos/931018/pexels-photo-931018.jpeg",
      "https://images.unsplash.com/photo-1689782918517-651eac82c5e1",
    ],
    faqs: [
      {
        question: "Which pilgrimage destinations do you serve?",
        answer:
          "We offer services to major pilgrimage sites including Char Dham (Kedarnath, Badrinath), Vaishno Devi, Shirdi, Tirupati, and many regional temples. Contact us for specific destination availability.",
      },
      {
        question: "Is helicopter pilgrimage suitable for senior citizens?",
        answer:
          "Absolutely! Our service is ideal for senior citizens and those with mobility challenges. We provide comfortable seating, assistance during boarding, and can accommodate wheelchairs.",
      },
      {
        question: "What about darshan arrangements?",
        answer:
          "We partner with local service providers to arrange VIP darshan, accommodation, and ground transportation at most pilgrimage destinations.",
      },
      {
        question: "Can we book a multi-destination pilgrimage tour?",
        answer:
          "Yes, we offer customized multi-destination packages. Cover multiple temples or heritage sites in a single trip with our tailored itineraries.",
      },
      {
        question: "What is the best season for helicopter pilgrimages?",
        answer:
          "Most destinations are accessible year-round, though mountain shrines have specific seasons. We advise on optimal timing based on weather patterns and temple schedules.",
      },
    ],
    icon: Landmark,
  };

  return <ServicePageTemplate {...serviceData} />;
};

export default TempleHeritage;
